import React from 'react';
import { Input } from '@/components/ui/input';
import { ipFixedPrefix, hostPart, fullIp } from '@/lib/subnet';

// IP input that, when a clean octet-aligned subnet (/8, /16, /24) is known,
// shows the fixed network prefix as a static grey add-on and only asks the user
// for the VARIABLE host part (e.g. "55" for a /24, "10.55" for a /16). The value
// exchanged with the parent is always the FULL IPv4 address, so nothing else in
// the app needs to change. Without a clean prefix it falls back to a plain
// full-address input.
export const HostIpInput = ({ cidr, value, onChange, placeholder = '', invalid = false, className = '', testid }) => {
  const p = ipFixedPrefix(cidr);

  if (!p) {
    return (
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`h-8 font-mono ${invalid ? 'border-[#B42318] text-[#B42318]' : ''} ${className}`}
        data-testid={testid}
      />
    );
  }

  const host = hostPart(cidr, value);
  return (
    <div
      className={`flex h-8 items-stretch overflow-hidden rounded-md border bg-white font-mono text-sm transition-colors focus-within:ring-2 focus-within:ring-[#0B5FFF]/30 ${
        invalid ? 'border-[#B42318]' : 'border-input'
      } ${className}`}
    >
      <span className="flex select-none items-center border-r border-input bg-muted px-2 text-[11px] text-muted-foreground">
        {p.fixed}
      </span>
      <input
        value={host}
        onChange={(e) => onChange(fullIp(cidr, e.target.value))}
        placeholder={placeholder}
        className={`h-full w-full min-w-0 bg-transparent px-2 outline-none placeholder:text-muted-foreground ${invalid ? 'text-[#B42318]' : ''}`}
        data-testid={testid}
      />
    </div>
  );
};
